<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="pAZ">
					Eartha Gets Well<br/>
					Original edition © 2010 Kristi Falk and Dr. Daniel Falk.<br/>
					Revised edition © 2012 Kristi Falk and Dr. Daniel Falk.<br/>
					All Rights Reserved.</p>
<p class="ct" id="pAd">
					No part of this book may be reproduced in any form or by any means, electronic, mechanical,
					digital, photocopying, or recording, except for the inclusion in a review, without
					permission in writing from the publisher. </p>
<p class="ct" id="pAat">
					This is a work of ﬁction. All of the characters, names, incidents, organizations,
					and dialogue in this novel are either the products of the author’s imagination or
					are used ﬁctitiously. </p>
<p class="ct" id="pAe">
					First edition printed in 2010 by Unibook.<br/>
					This second revised edition was published in 2012 by BQB Publishing.</p>
<p class="ct" id="pA4_">
					Published in the United States by BQB Publishing<br/>
					(Boutique of Quality Books Publishing)<br/>
<a href="http://www.bqbpublishing.com" id="Ab" target="_blank">www.bqbpublishing.com</a></p>
<p class="ct" id="pAU">
					Printed in the United States of America </p>
<p class="ct" id="pAC5">
					ISBN 978-1-937084-27-1 (h)<br/>
					ISBN 978-1-939371-19-5 (p)<br/>
					ISBN 978-1-937084-28-8 (e)</p>
<p class="ct" id="pAK">
					Library of Congress Number: 2012933927 </p>
<p class="ct" id="pAcL">
					Book cover and illustrations by Rob Peters<br/>
<a href="http://www.rob-peters.com" id="AW" target="_blank">www.rob-peters.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage2.vue?7c68cc7c